// extracted by mini-css-extract-plugin
module.exports = {"tabpanel":"Tabpanel_tabpanel__2AbnN"};